import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'bootstrap/dist/css/bootstrap.min.css'
import * as bootstrap from 'bootstrap'
import './style.css'

// Hacer bootstrap disponible globalmente para los composables
window.bootstrap = bootstrap

const app = createApp(App)
app.use(router)
app.mount('#app')
